export default __webpack_public_path__ + "static/media/jeremy.ac7b4dd6.png";